/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { DivBackgroundOpacity } from "@utils/extra-style";

const GeneralInfo = (props) => {
  const { t, data, column } = props;
  return (
    <>
      <DivBackgroundOpacity opacity={data.status ? "1" : "0.2"}>
        {column === "id" && <div>{data.id}</div>}
        {column === "name" && <div>{data.name}</div>}
        {column === "description" && <div>{data.description}</div>}
        {column === "adminCount" && <div>{data.adminCount}</div>}
        {/* {column === "admins" && <div>{data.adminInfo}</div>} */}
        {column === "admins" && (
          <div>
            {data.adminInfo.map((admin, index) => {
              return index + 1 === data.adminInfo.length
                ? admin.name
                : admin.name + ", ";
            })}
          </div>
        )}
      </DivBackgroundOpacity>
    </>
  );
};

GeneralInfo.propTypes = {
  t: PropTypes.func.isRequired,
  page: PropTypes.string,
};

GeneralInfo.defaultProps = {
  page: null,
};

export default withTranslation()(GeneralInfo);
